/* ══════════════════════════════════════════════════════════════════════════
   VOLTIO — JavaScript compartido del tema
   Tienda multicategoría contraentrega · Colombia · Base Dawn 16

   Este archivo es el ÚNICO JavaScript propio del tema. Las secciones no
   llevan <script>: se enganchan por atributos data-* y el comportamiento
   queda en un solo sitio auditable.

   Hooks implementados (Contrato de JavaScript del spec):
     data-vt-sticky / data-vt-sticky-anchor  barra fija de compra en móvil
     data-vt-sticky-hide                     apaga la barra fija mientras se ve
     data-vt-gallery                         miniaturas → foto principal
     data-vt-cod-form                        formulario de contraentrega
     data-vt-scrollto="#id"                  scroll suave al destino
     data-vt-qty                             botones − / + sobre un number
     data-vt-total / data-vt-precio          total del pedido = precio × cantidad
     data-vt-variantes                       selector de variantes de la ficha
     data-vt-order                           número de pedido en /pages/gracias
     data-vt-cart-drawer                     cajón del carrito — el contrato
                                             completo está en el snippet
                                             snippets/vt-cart-drawer.liquid
     data-vt-cart-open / data-vt-cart-count  icono del carrito de la cabecera

   Eventos que atiende el cajón en `document`: 'vt:carrito:abrir',
   'vt:carrito:cerrar' y 'vt:carrito:actualizado'. Tras cada cambio emite
   'vt:carrito:cambiado' con detail = { cart }.

   Los acordeones NO están aquí: son <details> nativos y no necesitan JS.
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ══ Utilidades ═══════════════════════════════════════════════════════ */

  // No se cachea el objeto: en el editor de temas el comerciante cambia el
  // endpoint o el WhatsApp y la sección se recarga sin recargar la página.
  function cfg() {
    window.VOLTIO = window.VOLTIO || {};
    return window.VOLTIO;
  }

  // Busca dentro del ámbito e incluye al propio ámbito si coincide: en
  // 'shopify:section:load' el target puede ser ya el elemento marcado.
  function all(scope, sel) {
    if (!scope) return [];
    var list = scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(sel)) : [];
    if (scope.matches && scope.matches(sel)) list.unshift(scope);
    return list;
  }

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function digits(v) {
    return String(v == null ? '' : v).replace(/\D+/g, '');
  }

  // Ocultar y mostrar con la utilidad del tema (display:none !important), que
  // gana a cualquier display que traiga la clase del elemento.
  function hideEl(el, on) {
    if (el) el.classList.toggle('vt-hide', !!on);
  }

  // Los pesos colombianos se escriben $129.900: punto en los miles, sin
  // decimales. Se agrupa a mano, igual que los snippets vt-price.liquid y
  // vt-cop.liquid —los tres tienen que dar la misma cifra siempre, y si se
  // toca uno se tocan los tres—, y por el mismo motivo que ellos:
  // window.VOLTIO.moneyFormat depende de cómo esté
  // configurada la tienda (puede traer decimales, coma o el código COP) e
  // Intl.NumberFormat('es-CO') NO agrupa los números de cuatro cifras — daría
  // "$1000" donde Liquid pinta "$1.000". Dos cifras distintas del mismo
  // producto en la misma pantalla es exactamente lo que rompe la confianza.
  function grupoMiles(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Entra el importe en CENTAVOS, que es como lo guarda Shopify y como viaja
  // en data-vt-precio y data-vt-amount.
  function formatCOP(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return '$' + grupoMiles(Math.round(n / 100));
  }

  // Guardas de inicialización: un WeakSet por hook evita volver a enganchar
  // el mismo nodo cuando init() se llama otra vez, y no ensucia el DOM.
  var seen = {
    sticky: new WeakSet(),
    gallery: new WeakSet(),
    cod: new WeakSet(),
    qty: new WeakSet(),
    total: new WeakSet(),
    variantes: new WeakSet(),
    gracias: new WeakSet(),
    carrito: new WeakSet()
  };

  function once(set, el) {
    if (set.has(el)) return false;
    set.add(el);
    return true;
  }

  // Funciones de limpieza por elemento, para soltar observers y listeners
  // cuando el editor desmonta una sección ('shopify:section:unload').
  var teardowns = new WeakMap();

  function remember(el, fn) {
    var list = teardowns.get(el) || [];
    list.push(fn);
    teardowns.set(el, list);
  }

  var uid = 0;
  function nextId(prefix) {
    uid += 1;
    return prefix + uid;
  }

  /* ══ 1 · Barra fija de compra ═════════════════════════════════════════
     La barra aparece cuando el botón de compra del bloque 05 se va por
     arriba, y desaparece cuando vuelve: si el botón real está a la vista,
     dos botones idénticos en pantalla solo estorban.

     Y se apaga también mientras el formulario de contraentrega está a la
     vista. Sin esto, en el celular conviven DOS botones naranjas en el mismo
     viewport: la regla 90/10 dice que el acento aparece una sola vez por
     pantalla, y justo esa es la pantalla donde se cierra la venta. */

  // Estado por barra: la barra se enciende solo si el ancla ya pasó por
  // arriba (passed) y el formulario no está tapando la pantalla (covered).
  var stickyState = new WeakMap();

  // Puede vivir en OTRA sección y montarse después (el editor de temas carga
  // las secciones sueltas), así que se busca en el documento entero y se
  // reintenta en cada init().
  function stickyHideTarget(bar) {
    // El atributo vive EN LA BARRA y su valor es el selector del destino.
    // Buscarlo con querySelector('[data-vt-sticky-hide]') devolvía la barra
    // misma: se observaba a sí misma, así que al verse se ocultaba, al
    // ocultarse dejaba de verse, y volvía a mostrarse — parpadeo infinito y
    // un botón imposible de tocar, justo en móvil, que es todo el tráfico.
    var sel = bar && bar.getAttribute && bar.getAttribute('data-vt-sticky-hide');
    if (sel && sel.charAt(0) === '#') {
      // Solo sirve si es un ancla: el destino puede ser una URL de otra
      // página, y querySelector('/pages/gracias') lanza excepción.
      try {
        var t = document.querySelector(sel);
        if (t) return t;
      } catch (e) { /* selector inválido: se cae a los respaldos */ }
    }
    return document.querySelector('[data-vt-cod-form]') ||
           document.getElementById('pedido');
  }

  function attachStickyHide(bar) {
    var rec = stickyState.get(bar);
    if (!rec || rec.hideOn) return;

    var target = stickyHideTarget(bar);
    // Si el destino resuelto ES la propia barra, no se observa: eso es el
    // bucle que se acaba de arreglar.
    if (!target || target === bar || bar.contains(target)) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { rec.covered = entry.isIntersecting; });
        rec.apply();
      }, { threshold: 0 });
      io.observe(target);
      rec.hideOn = true;
      remember(bar, function () { io.disconnect(); });
    } else {
      // Sin IntersectionObserver lo mide el respaldo de scroll de abajo.
      rec.hideTarget = target;
      rec.hideOn = true;
    }
  }

  function refreshStickyHide() {
    all(document, '[data-vt-sticky]').forEach(attachStickyHide);
  }

  function initSticky(scope) {
    all(scope, '[data-vt-sticky]').forEach(function (bar) {
      if (!once(seen.sticky, bar)) return;

      // El ancla vive en la misma sección que la barra; se busca fuera solo
      // como último recurso (barra en un snippet global, por ejemplo).
      var section = bar.closest ? bar.closest('.shopify-section') : null;
      var anchor = (section && section.querySelector('[data-vt-sticky-anchor]')) ||
                   document.querySelector('[data-vt-sticky-anchor]');

      // Sin ancla no hay nada que observar: la barra se queda oculta en vez
      // de aparecer siempre y tapar contenido.
      if (!anchor) return;

      var rec = {
        passed: false,
        covered: false,
        hideOn: false,
        hideTarget: null,
        apply: function () { bar.classList.toggle('is-on', rec.passed && !rec.covered); }
      };
      stickyState.set(bar, rec);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // Solo cuenta salir por ARRIBA. Si el ancla todavía está por
            // debajo del viewport (nadie ha bajado aún) la barra no sale.
            rec.passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          });
          rec.apply();
        }, { threshold: 0 });

        io.observe(anchor);
        remember(bar, function () { io.disconnect(); });
      } else {
        // Respaldo para navegadores sin IntersectionObserver: mismo criterio,
        // leído en rAF para no medir el layout en cada píxel de scroll.
        var ticking = false;
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            rec.passed = anchor.getBoundingClientRect().bottom < 0;
            if (rec.hideTarget) {
              var r = rec.hideTarget.getBoundingClientRect();
              rec.covered = r.top < (window.innerHeight || 0) && r.bottom > 0;
            }
            rec.apply();
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        remember(bar, function () { window.removeEventListener('scroll', onScroll); });
      }

      attachStickyHide(bar);
    });
  }

  /* ══ 2 · Galería ══════════════════════════════════════════════════════
     Sin carrusel y sin autoplay: se toca una miniatura y cambia la foto
     grande. Nada se mueve solo. */

  var THUMB_SEL = '[data-vt-gallery-thumb], .vt-gallery__thumb';

  function galleryMain(gallery) {
    var flagged = gallery.querySelector('[data-vt-gallery-main]');
    if (flagged) return flagged.tagName === 'IMG' ? flagged : flagged.querySelector('img');

    var inMain = gallery.querySelector('.vt-gallery__main img');
    if (inMain) return inMain;

    // Último recurso: la primera imagen que no viva dentro de una miniatura.
    var imgs = gallery.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest(THUMB_SEL)) return imgs[i];
    }
    return null;
  }

  function thumbSource(thumb) {
    var d = thumb.dataset || {};
    if (d.src) return { src: d.src, srcset: d.srcset || '', sizes: d.sizes || '', alt: d.alt, w: d.width, h: d.height };

    // Si la sección no dejó el original en data-src, se reutiliza la propia
    // miniatura: se verá menos nítida, pero la interacción nunca queda muerta.
    var img = thumb.querySelector('img');
    if (!img) return null;
    return { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '', sizes: img.getAttribute('sizes') || '', alt: img.getAttribute('alt') };
  }

  function selectThumb(gallery, thumb) {
    var main = galleryMain(gallery);
    var data = thumbSource(thumb);

    if (main && data && data.src) {
      main.src = data.src;
      if (data.srcset) main.setAttribute('srcset', data.srcset); else main.removeAttribute('srcset');
      if (data.sizes) main.setAttribute('sizes', data.sizes);
      if (data.alt != null) main.alt = data.alt;
      if (data.w) main.setAttribute('width', data.w);
      if (data.h) main.setAttribute('height', data.h);
      // La foto ya no es el LCP después de la primera interacción.
      main.setAttribute('loading', 'eager');
      main.removeAttribute('fetchpriority');
    }

    all(gallery, THUMB_SEL).forEach(function (t) {
      if (t === thumb) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  }

  function initGallery(scope) {
    all(scope, '[data-vt-gallery]').forEach(function (gallery) {
      if (!once(seen.gallery, gallery)) return;

      var thumbs = function () { return all(gallery, THUMB_SEL); };
      if (!thumbs().length || !galleryMain(gallery)) return;

      thumbs().forEach(function (t) {
        // Si la miniatura no es <button> ni <a>, hay que darle rol y foco a
        // mano o el teclado no la alcanza nunca.
        if (!t.matches('button, a[href]')) {
          if (!t.hasAttribute('role')) t.setAttribute('role', 'button');
          if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '0');
        }
      });

      if (!gallery.querySelector('[aria-current="true"]')) {
        thumbs()[0].setAttribute('aria-current', 'true');
      }

      var onClick = function (e) {
        var thumb = e.target instanceof Element ? e.target.closest(THUMB_SEL) : null;
        if (!thumb || !gallery.contains(thumb)) return;
        e.preventDefault(); // por si la miniatura es un <a> al archivo grande
        selectThumb(gallery, thumb);
      };

      var onKey = function (e) {
        var thumb = e.target instanceof Element ? e.target.closest(THUMB_SEL) : null;
        if (!thumb || !gallery.contains(thumb)) return;

        var list = thumbs();
        var i = list.indexOf(thumb);
        var next = -1;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % list.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + list.length) % list.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = list.length - 1;
        else if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          // Un <button> ya dispara click solo; esto es para las miniaturas
          // que la sección haya montado sobre otro elemento.
          if (thumb.matches('button, a[href]')) return;
          e.preventDefault();
          selectThumb(gallery, thumb);
          return;
        } else return;

        e.preventDefault();
        list[next].focus();
        selectThumb(gallery, list[next]);
      };

      gallery.addEventListener('click', onClick);
      gallery.addEventListener('keydown', onKey);
      remember(gallery, function () {
        gallery.removeEventListener('click', onClick);
        gallery.removeEventListener('keydown', onKey);
      });
    });
  }

  /* ══ 3 · Formulario de contraentrega ══════════════════════════════════
     Seis campos y ni uno más. Departamento y ciudad encadenados: una ciudad
     mal escrita es un paquete que no llega, y ese flete se paga dos veces. */

  // Textos de ÚLTIMO recurso. El mensaje bueno es el que el comerciante
  // configura en el editor y Liquid ya dejó pintado en el DOM; estos solo
  // entran cuando ese hueco viene vacío. Ver msgFor().
  var MSG = {
    nombre: 'Escribe tu nombre completo.',
    celular: 'El celular son 10 dígitos y empieza por 3.',
    departamento: 'Elige tu departamento.',
    ciudad: 'Elige tu ciudad.',
    direccion: 'Escribe la dirección donde recibes el pedido.',
    listas: 'No pudimos cargar la lista de departamentos. Revisa tu conexión y toca aquí otra vez.',
    enviando: 'Enviando tu pedido…',
    fallo: 'No pudimos registrar tu pedido en este momento. Vuelve a intentarlo o termínalo por WhatsApp: te lo confirmamos enseguida.'
  };

  // Ruta de la confirmación cuando la sección no configura otra.
  var GRACIAS_URL = '/pages/gracias';
  var GRACIAS_PARAM = 'pedido';

  // Un celular colombiano son 10 dígitos que empiezan por 3. Se limpia lo que
  // el visitante pegue (+57, espacios, guiones) antes de juzgarlo.
  function normalizePhone(v) {
    var d = digits(v);
    // Los ceros de marcación (0057, 057) y el indicativo 57 sobran: un móvil
    // colombiano empieza por 3, nunca por 0.
    d = d.replace(/^0+/, '');
    if (d.length === 12 && d.indexOf('57') === 0) d = d.slice(2);
    return d;
  }

  // Las reglas solo dicen sí o no. El texto del error lo pone msgFor(), que
  // lee lo configurado: antes la regla devolvía el mensaje fijo y no había
  // forma de que el ajuste del editor llegara hasta aquí.
  var RULES = {
    nombre: function (v) { return v.trim() !== ''; },
    celular: function (v) { var d = normalizePhone(v); return d.length === 10 && d.charAt(0) === '3'; },
    departamento: function (v) { return v.trim() !== ''; },
    ciudad: function (v) { return v.trim() !== ''; },
    direccion: function (v) { return v.trim() !== ''; }
  };

  function fieldOf(control) {
    return (control.closest && control.closest('.vt-field')) || control.parentElement;
  }

  function errorBox(control) {
    var wrap = fieldOf(control);
    if (!wrap) return null;
    var box = wrap.querySelector('.vt-field__error');
    if (!box) {
      // Si la sección no dejó hueco para el mensaje, se crea: un campo en
      // rojo sin texto no le dice nada a nadie, y menos a un lector de pantalla.
      box = document.createElement('p');
      box.className = 'vt-field__error';
      wrap.appendChild(box);
    }
    if (!box.id) box.id = nextId('vt-error-');
    return box;
  }

  /* El mensaje de error de cada campo lo escribe el comerciante en el editor
     y el snippet vt-form-field lo deja YA pintado dentro del .vt-field, oculto
     por CSS hasta que hay error. Este módulo lo escribía encima con un texto
     fijo, así que el ajuste existía y no servía de nada.

     Se guarda una copia en cuanto se monta el formulario, antes de tocar
     nada: en cuanto pintamos el primer error el original se habría perdido —
     y el mismo hueco lo reutiliza el aviso de «no cargó la lista de
     departamentos», que no es el mensaje del campo. */
  var msgSeed = new WeakMap();

  function seedMsg(control) {
    if (!control || msgSeed.has(control)) return;
    var wrap = fieldOf(control);
    var box = wrap ? wrap.querySelector('.vt-field__error') : null;
    msgSeed.set(control, box ? (box.textContent || '').trim() : '');
  }

  function msgFor(control, key) {
    seedMsg(control);
    return msgSeed.get(control) || MSG[key];
  }

  function describe(control, id, on) {
    var ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var i = ids.indexOf(id);
    if (on && i < 0) ids.push(id);
    if (!on && i >= 0) ids.splice(i, 1);
    if (ids.length) control.setAttribute('aria-describedby', ids.join(' '));
    else control.removeAttribute('aria-describedby');
  }

  function setError(control, msg) {
    var wrap = fieldOf(control);
    var box = errorBox(control);
    if (wrap) wrap.classList.add('is-error');
    if (box) {
      box.textContent = msg;
      describe(control, box.id, true);
    }
    control.setAttribute('aria-invalid', 'true');
  }

  function clearError(control) {
    var wrap = fieldOf(control);
    var box = wrap ? wrap.querySelector('.vt-field__error') : null;
    if (wrap) wrap.classList.remove('is-error');
    control.removeAttribute('aria-invalid');
    // El texto se deja puesto: sin .is-error el CSS lo oculta igual.
    if (box && box.id) describe(control, box.id, false);
  }

  // El dataset de departamentos y ciudades se pide UNA sola vez y tarde.
  var colombiaPromise = null;

  function loadColombia() {
    // Nunca en la carga inicial: son kilobytes que competirían con la foto
    // del producto, que es el LCP y lo único que decide si hay venta.
    if (colombiaPromise) return colombiaPromise;

    var url = cfg().colombiaUrl;
    if (!url) return Promise.reject(new Error('vt-colombia.json sin URL'));

    colombiaPromise = fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!Array.isArray(data) || !data.length) throw new Error('formato inesperado');
        return data;
      })
      .catch(function (err) {
        // Se suelta la caché para que el siguiente toque vuelva a intentarlo:
        // en móvil la primera petición se pierde a menudo al cambiar de red.
        colombiaPromise = null;
        throw err;
      });

    return colombiaPromise;
  }

  function fillOptions(select, values, fallbackLabel) {
    var placeholder = select.querySelector('option[value=""]');
    var label = placeholder ? placeholder.textContent : fallbackLabel;

    select.innerHTML = '';
    // El placeholder se deja seleccionable: si lo deshabilitamos, en móvil el
    // visitante no puede volver atrás una vez elegido.
    select.appendChild(new Option(label, ''));
    values.forEach(function (v) { select.appendChild(new Option(v, v)); });
    select.value = '';
  }

  var warnedEndpoint = false;
  function warnMissingEndpoint() {
    if (warnedEndpoint) return;
    warnedEndpoint = true;
    console.warn('[Voltio] settings.vt_cod_endpoint está vacío: el formulario de contraentrega hará el envío nativo del navegador y no creará el pedido.');
  }

  function initCodForm(scope) {
    all(scope, '[data-vt-cod-form]').forEach(function (form) {
      if (!once(seen.cod, form)) return;

      // Se apaga la validación nativa a propósito: así la única validación
      // que corre es la de aquí, en español y con .is-error, tanto si el
      // markup trae novalidate como si no. Si este JS no cargara, el
      // required/pattern del HTML sigue protegiendo el envío.
      form.noValidate = true;

      var pick = function (key, extra) {
        return form.querySelector('[data-vt-field="' + key + '"]') ||
               (extra ? form.querySelector(extra) : null) ||
               form.querySelector('[name="' + key + '"]');
      };

      var ctl = {
        nombre: pick('nombre'),
        celular: pick('celular'),
        departamento: pick('departamento', '[data-vt-dept]'),
        ciudad: pick('ciudad', '[data-vt-city]'),
        direccion: pick('direccion')
      };

      // Copia de los mensajes configurados antes de que nada escriba encima.
      Object.keys(ctl).forEach(function (k) { seedMsg(ctl[k]); });

      var dept = ctl.departamento;
      var city = ctl.ciudad;
      var submit = form.querySelector('[data-vt-submit]') || form.querySelector('[type="submit"]');
      var rows = null;
      var sending = false;
      var cargando = false;

      if (!cfg().codEndpoint) warnMissingEndpoint();

      /* ── cadena departamento → ciudad ── */

      if (dept && city) {
        city.disabled = true;

        var prime = function () {
          // El testigo es una variable, no un data-*: `data-vt-loading` ya
          // significa otra cosa en este formulario (el texto del botón
          // mientras envía) y dos sentidos en el mismo nombre se acaban
          // pisando.
          if (rows || cargando) return;
          cargando = true;
          loadColombia().then(function (data) {
            rows = data;
            cargando = false;
            fillOptions(dept, data.map(function (r) { return r.d; }), 'Elige tu departamento');
            clearError(dept);
          }).catch(function () {
            cargando = false;
            setError(dept, MSG.listas);
          });
        };

        dept.addEventListener('pointerdown', prime);
        dept.addEventListener('focus', prime);
        // Precalentado: el primer campo del formulario es el nombre, así que
        // al tocar cualquier campo la lista ya viene en camino y el select
        // no se abre vacío. Sigue sin pesar en la carga inicial.
        form.addEventListener('focusin', prime, { once: true });
        form.addEventListener('pointerdown', prime, { once: true });

        dept.addEventListener('change', function () {
          clearError(dept);
          // Cambiar de departamento invalida la ciudad elegida: un municipio
          // del departamento anterior es un paquete que no llega.
          city.value = '';
          clearError(city);

          var row = null;
          (rows || []).forEach(function (r) { if (r.d === dept.value) row = r; });

          if (!row) {
            fillOptions(city, [], 'Elige tu ciudad');
            city.disabled = true;
            return;
          }
          fillOptions(city, row.c || [], 'Elige tu ciudad');
          city.disabled = false;
        });
      }

      /* ── validación ── */

      var keyOf = function (el) {
        for (var k in ctl) {
          if (Object.prototype.hasOwnProperty.call(ctl, k) && ctl[k] === el) return k;
        }
        return null;
      };

      var checkOne = function (key) {
        var el = ctl[key];
        if (!el) return true;
        if (RULES[key](el.value || '')) {
          clearError(el);
          // Se devuelve el celular ya limpio para que el backend reciba
          // siempre diez dígitos, no lo que se pegó desde WhatsApp.
          if (key === 'celular') el.value = normalizePhone(el.value);
          return true;
        }
        setError(el, msgFor(el, key));
        return false;
      };

      var onFocusOut = function (e) {
        var key = keyOf(e.target);
        if (key) checkOne(key);
      };

      // Al corregir, el error se va sin esperar al blur: dejar el campo en
      // rojo cuando ya está bien es lo que hace abandonar el formulario.
      var onEdit = function (e) {
        var key = keyOf(e.target);
        if (!key) return;
        var wrap = fieldOf(e.target);
        if (wrap && wrap.classList.contains('is-error') && RULES[key](e.target.value || '')) {
          clearError(e.target);
        }
      };

      form.addEventListener('focusout', onFocusOut);
      form.addEventListener('input', onEdit);
      form.addEventListener('change', onEdit);

      /* ── envío ── */

      /* La sección ya pinta el aviso de fallo —título, explicación y botón de
         WhatsApp, los tres configurables— y lo deja con `hidden`. Nadie se lo
         quitaba nunca: este módulo construía otro aviso con texto fijo, así
         que lo que el comerciante escribía en el editor no se leía jamás.

         Se filtran los controles de formulario porque `data-vt-error` es un
         nombre corto y goloso: si algún día lo lleva también un <input>, la
         caja no puede ser ese input. */
      var failBox = function () {
        var found = null;
        all(form, '[data-vt-error]').forEach(function (el) {
          if (!found && !el.matches('input, select, textarea')) found = el;
        });
        return found;
      };

      var statusBox = function () {
        var box = form.querySelector('[data-vt-cod-status]');
        if (!box) {
          box = document.createElement('div');
          box.setAttribute('data-vt-cod-status', '');
          // Junto al botón, que es donde está mirando el visitante cuando
          // el envío falla.
          if (submit && submit.parentNode) submit.parentNode.insertBefore(box, submit);
          else form.appendChild(box);
        }
        return box;
      };

      var hideStatus = function () {
        var box = form.querySelector('[data-vt-cod-status]');
        if (box) { box.hidden = true; box.textContent = ''; }
        // La caja de la sección se apaga, no se vacía: sus textos son los del
        // editor y hay que poder volver a encenderlos tal cual.
        var liquidBox = failBox();
        if (liquidBox) liquidBox.hidden = true;
      };

      // El texto de «enviando» es un ajuste de la sección y viaja en
      // data-vt-loading; solo si viene vacío entra el de por defecto.
      var txtEnviando = (submit && submit.getAttribute('data-vt-loading') || '').trim() || MSG.enviando;
      var txtBoton = null;

      var setBusy = function (on) {
        if (!submit) return;
        var label = submit.querySelector('[data-vt-btn-label]') || submit;
        if (on) {
          // Se cambia el texto, no se borra: un botón vacío parece roto.
          if (txtBoton == null) txtBoton = label.textContent.trim();
          label.textContent = txtEnviando;
          submit.setAttribute('aria-busy', 'true');
        } else {
          if (txtBoton != null) label.textContent = txtBoton;
          submit.removeAttribute('aria-busy');
        }
        // El CSS de la sección apaga el botón con [aria-busy] en el <form>.
        form.setAttribute('aria-busy', on ? 'true' : 'false');
        submit.disabled = on;
      };

      var buildPayload = function () {
        var out = {};
        new FormData(form).forEach(function (value, key) {
          if (typeof value !== 'string') return; // los archivos no se envían
          if (Object.prototype.hasOwnProperty.call(out, key)) out[key] = [].concat(out[key], value);
          else out[key] = value;
        });
        if (out.celular) out.celular = normalizePhone(out.celular);
        out.pagina = window.location.href;
        if (document.referrer) out.referencia = document.referrer;

        // La atribución del anuncio de Instagram o TikTok viaja en la URL y
        // se pierde en cuanto el visitante navega: se manda con el pedido.
        var utm = {};
        new URLSearchParams(window.location.search).forEach(function (v, k) {
          if (/^(utm_|fbclid|ttclid|gclid|igshid)/i.test(k)) utm[k] = v;
        });
        if (Object.keys(utm).length) out.utm = utm;

        return out;
      };

      var whatsappLink = function (payload) {
        var num = digits(cfg().whatsapp || '');
        if (!num) return null; // sin número configurado no se pinta un enlace roto

        var titulo = payload.producto_titulo || payload.producto || payload.titulo || document.title;
        var lines = ['Hola, quiero terminar mi pedido contra entrega.'];
        if (titulo) lines.push('Producto: ' + titulo);
        if (payload.nombre) lines.push('Nombre: ' + payload.nombre);
        if (payload.celular) lines.push('Celular: ' + payload.celular);
        if (payload.ciudad || payload.departamento) {
          lines.push('Ciudad: ' + [payload.ciudad, payload.departamento].filter(Boolean).join(', '));
        }
        if (payload.direccion) lines.push('Dirección: ' + payload.direccion);
        lines.push(payload.pagina);

        return 'https://wa.me/' + num + '?text=' + encodeURIComponent(lines.join('\n'));
      };

      // Un pedido nunca se pierde en silencio: si el backend no responde, el
      // visitante ve el motivo y una salida por WhatsApp con todo escrito.
      var showFailure = function (payload) {
        var href = whatsappLink(payload);
        var box = failBox();

        if (box) {
          // El enlace nace desde Liquid con un mensaje genérico: se le pega lo
          // que el comprador ya escribió para que no tenga que dictarlo otra
          // vez por chat.
          var slot = box.querySelector('[data-vt-wa]');
          var link = (slot || box).querySelector('a[href]');
          if (link && href) link.href = href;
          box.hidden = false;
        } else {
          // Respaldo para un marcado que no traiga la caja: mejor un aviso con
          // el texto de por defecto que un botón que se queda mudo.
          box = statusBox();
          box.hidden = false;
          box.className = 'vt-note vt-note--bad vt-stack';
          box.setAttribute('role', 'alert');
          box.textContent = '';

          var p = document.createElement('p');
          p.textContent = MSG.fallo;
          box.appendChild(p);

          if (href) {
            var a = document.createElement('a');
            a.className = 'vt-btn vt-btn--wa vt-btn--full';
            a.href = href;
            a.target = '_blank';
            a.rel = 'noopener';
            a.textContent = 'Terminar mi pedido por WhatsApp';
            box.appendChild(a);
          }
        }

        box.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
      };

      /* A dónde llega el comprador con el pedido ya registrado. Las dos piezas
         son ajustes de la sección: la página de gracias y el nombre del
         parámetro que lleva el número de pedido — el mismo que lee la sección
         de gracias en data-vt-order-param. Antes iba fijo a /pages/gracias
         ?pedido=, y cambiar el ajuste no cambiaba nada. */
      var successUrl = function (numero) {
        var base = (form.getAttribute('data-vt-success-url') || '').trim() || GRACIAS_URL;
        var param = (form.getAttribute('data-vt-order-param') || '').trim() || GRACIAS_PARAM;
        if (!numero) return base;
        try {
          var u = new URL(base, window.location.href);
          u.searchParams.set(param, String(numero));
          return u.toString();
        } catch (err) {
          // Navegador sin URL o base rara: se pega el parámetro a mano, y se
          // respeta la querystring que la URL configurada ya traiga.
          return base + (base.indexOf('?') >= 0 ? '&' : '?') +
                 encodeURIComponent(param) + '=' + encodeURIComponent(numero);
        }
      };

      var send = function (endpoint) {
        var payload = buildPayload();
        var controller = ('AbortController' in window) ? new AbortController() : null;
        // Una red móvil colgada no puede dejar el botón muerto para siempre.
        var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 20000);

        sending = true;
        setBusy(true);
        hideStatus();

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'omit',
          signal: controller ? controller.signal : undefined
        }).then(function (res) {
          return res.json().catch(function () { return null; }).then(function (body) {
            if (!res.ok || (body && body.ok === false)) throw new Error('respuesta ' + res.status);
            return body;
          });
        }).then(function (body) {
          window.clearTimeout(timer);
          var numero = body && (body.numero || body.pedido || body.order_number || body.name || body.id);
          // El botón se queda deshabilitado a propósito: rehabilitarlo en el
          // parpadeo previo a la navegación permitiría un pedido duplicado.
          window.location.assign(successUrl(numero));
        }).catch(function () {
          window.clearTimeout(timer);
          sending = false;
          setBusy(false);
          showFailure(payload);
        });
      };

      form.addEventListener('submit', function (e) {
        var invalid = [];
        ['nombre', 'celular', 'departamento', 'ciudad', 'direccion'].forEach(function (key) {
          if (ctl[key] && !checkOne(key)) invalid.push(ctl[key]);
        });

        if (invalid.length) {
          e.preventDefault();
          invalid[0].focus();
          return;
        }

        var endpoint = cfg().codEndpoint;
        if (!endpoint) {
          // Dejar pasar el envío nativo NO es inocuo: sin endpoint el <form> se
          // pinta sin `action`, así que el navegador haría POST contra la propia
          // URL del producto. Shopify responde con un error o una recarga, el
          // pedido se pierde y el comprador no se entera de nada — y esto es
          // justo el estado en que se despacha el tema, con vt_cod_endpoint
          // vacío. Se corta el envío y se le ofrece la salida por WhatsApp con
          // sus datos ya escritos, que es lo que promete la sección.
          e.preventDefault();
          warnMissingEndpoint();
          showFailure(buildPayload());
          return;
        }

        e.preventDefault();
        if (sending) return;
        send(endpoint);
      });

      remember(form, function () {
        form.removeEventListener('focusout', onFocusOut);
        form.removeEventListener('input', onEdit);
        form.removeEventListener('change', onEdit);
      });
    });
  }

  /* ══ 4 · Scroll suave ═════════════════════════════════════════════════ */

  /* El header no lleva el sticky en el mismo nodo que la marca: `position:
     sticky` está en el <header> de la sección (la clase .vt-header-section
     la pone el schema), mientras que .vt-header es el div interior que solo
     pinta el fondo. Mirar únicamente la posición computada de .vt-header
     devolvía 0 y el scroll al formulario caía por debajo del header pegado,
     tapando el título del bloque.

     Por eso se sube desde el candidato hasta encontrar el elemento que de
     verdad está pegado, y se mide ESE. El orden de los candidatos deja
     data-vt-header primero (el atributo del contrato) y sigue con la clase
     del schema y la del div, para que funcione se ponga donde se ponga. */

  var HEADER_SELS = ['[data-vt-header]', '.vt-header-section', '.vt-header'];

  function stickyAncestor(el) {
    var node = el;
    while (node && node.nodeType === 1 && node !== document.body) {
      var pos = window.getComputedStyle(node).position;
      if (pos === 'fixed' || pos === 'sticky') return node;
      node = node.parentElement;
    }
    return null;
  }

  function headerOffset() {
    for (var i = 0; i < HEADER_SELS.length; i++) {
      var el = document.querySelector(HEADER_SELS[i]);
      if (!el) continue;
      var pegado = stickyAncestor(el);
      // Solo estorba si está pegado arriba; si hace scroll con la página, no.
      if (pegado) return pegado.getBoundingClientRect().height;
    }
    return 0;
  }

  function onScrollToClick(e) {
    var trigger = e.target instanceof Element ? e.target.closest('[data-vt-scrollto]') : null;
    if (!trigger) return;

    var sel = trigger.getAttribute('data-vt-scrollto');
    if (!sel) return;

    var target = null;
    try { target = document.querySelector(sel); }
    catch (err) { target = document.getElementById(sel.replace(/^#/, '')); }

    // Si el destino no está en esta página se deja pasar el clic: puede ser
    // un enlace de verdad a otra URL.
    if (!target) return;

    e.preventDefault();

    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion() ? 'auto' : 'smooth' });

    // El foco tiene que viajar con el scroll o quien navega con teclado se
    // queda arriba mientras la página se mueve sin él.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (err2) { /* navegadores viejos */ }
  }

  /* ══ 5 · Cantidad ═════════════════════════════════════════════════════ */

  function initQty(scope) {
    all(scope, '[data-vt-qty]').forEach(function (box) {
      if (!once(seen.qty, box)) return;

      var input = box.querySelector('input[data-vt-qty-input]') || box.querySelector('input[type="number"]');
      if (!input) return;

      var min = function () { return input.min !== '' ? Number(input.min) : 1; };
      var max = function () { return input.max !== '' ? Number(input.max) : Infinity; };
      var step = function () { var s = Number(input.step); return s > 0 ? s : 1; };
      var current = function () { var n = parseInt(input.value, 10); return isFinite(n) ? n : min(); };
      var clamp = function (n) { return Math.min(Math.max(n, min()), max()); };

      var dirOf = function (btn) {
        if (!btn) return 0;
        if (btn.hasAttribute('data-vt-qty-step')) return Number(btn.getAttribute('data-vt-qty-step')) < 0 ? -1 : 1;
        if (btn.matches('[data-vt-qty-minus], [name="minus"], .vt-qty__minus')) return -1;
        if (btn.matches('[data-vt-qty-plus], [name="plus"], .vt-qty__plus')) return 1;
        return 0;
      };

      // En el tope, el botón se deshabilita en vez de no hacer nada: un botón
      // que se pulsa y no responde se lee como un tema roto.
      var sync = function () {
        var n = current();
        all(box, 'button').forEach(function (b) {
          var d = dirOf(b);
          if (!d) return;
          b.disabled = d < 0 ? n <= min() : n >= max();
        });
      };

      var set = function (n) {
        var next = clamp(n);
        if (String(next) === input.value) { sync(); return; }
        input.value = String(next);
        // 'change' y no 'input': es lo que escuchan el carrito de Dawn y el
        // resto del tema para recalcular el total.
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      };

      var onClick = function (e) {
        var btn = e.target instanceof Element ? e.target.closest('button, [data-vt-qty-step]') : null;
        if (!btn || !box.contains(btn)) return;
        var d = dirOf(btn);
        if (!d) return;
        e.preventDefault();
        set(current() + d * step());
      };

      // Si lo escriben a mano también se respeta el mínimo y el máximo.
      var onChange = function () {
        var n = clamp(current());
        if (String(n) !== input.value) input.value = String(n);
        sync();
      };

      box.addEventListener('click', onClick);
      input.addEventListener('change', onChange);
      sync();

      remember(box, function () {
        box.removeEventListener('click', onClick);
        input.removeEventListener('change', onChange);
      });
    });
  }

  /* ══ 6 · Total del pedido ═════════════════════════════════════════════
     El resumen nace pintado con el precio de UNA unidad. Si el comprador
     pide tres y el total sigue diciendo el precio de una, el transportador
     le cobra el triple en la puerta: eso es una promesa rota en la cara del
     cliente y una devolución segura, con el flete de ida y el de vuelta
     pagados por la tienda. El total se recalcula en cada cambio. */

  function totalRoot(el) {
    if (!el.closest) return document;
    return el.closest('[data-vt-cod-form]') || el.closest('form') || document;
  }

  function paintTotal(root) {
    var scope = root || document;
    var out = scope.querySelector('[data-vt-total]');
    var unitEl = scope.querySelector('[data-vt-precio]');
    if (!out || !unitEl) return;

    // El importe ya viene en centavos desde Liquid: no se lee del texto
    // formateado, que trae puntos y símbolo.
    var unit = parseInt(unitEl.value != null && unitEl.value !== '' ? unitEl.value : unitEl.getAttribute('data-vt-precio'), 10);
    if (!isFinite(unit)) return;

    var qtyEl = scope.querySelector('[name="cantidad"]') ||
                scope.querySelector('[data-vt-qty] input[type="number"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    if (!isFinite(qty) || qty < 1) qty = 1;

    out.textContent = formatCOP(unit * qty);
  }

  function initTotal(scope) {
    all(scope, '[data-vt-total]').forEach(function (out) {
      if (!once(seen.total, out)) return;

      var root = totalRoot(out);

      var onChange = function (e) {
        var t = e.target;
        if (!t || !t.getAttribute) return;
        // Solo lo que mueve el total: la cantidad y el precio de la variante.
        if (t.name === 'cantidad' || t.hasAttribute('data-vt-precio') || t.hasAttribute('data-vt-qty-input')) {
          paintTotal(root);
        }
      };

      root.addEventListener('change', onChange);
      // 'input' además de 'change' porque la cantidad también se escribe a
      // mano y el total no puede esperar al blur.
      root.addEventListener('input', onChange);

      // Primer pintado: normaliza el `money` de Liquid al mismo formato que
      // el precio de la ficha ($129.900) aunque nadie toque nada.
      paintTotal(root);

      remember(out, function () {
        root.removeEventListener('change', onChange);
        root.removeEventListener('input', onChange);
      });
    });
  }

  /* ══ 7 · Variantes ════════════════════════════════════════════════════
     La ficha pinta radios y selects, un hidden con el id de la variante y un
     JSON con todas. Sin este módulo el comprador elige una talla y pide otra,
     con el precio de otra: el markup estaba vivo y el pedido, equivocado.

     EL CANDADO (Ley 1480): al repintar el precio, este módulo solo toca los
     nodos que Liquid YA pintó. Nunca crea un [data-vt-price-was]. Si el
     contenedor no trae data-vt-ancla="true" —el metafield vt.precio_ancla_real
     del producto—, no hay tachado ni ahorro, pase lo que pase con la variante.
     Inventar un precio anterior es publicidad engañosa y la SIC multa por eso. */

  function paintPrice(box, variant) {
    var now = box.querySelector('[data-vt-price-now]');
    var was = box.querySelector('[data-vt-price-was]');
    var save = box.querySelector('[data-vt-price-save]');

    var price = Number(variant.price);
    if (now && isFinite(price)) {
      now.textContent = formatCOP(price);
      now.setAttribute('data-vt-amount', String(price));
    }

    var autorizado = box.getAttribute('data-vt-ancla') === 'true';
    var antes = Number(variant.compare_at_price);
    var real = autorizado && isFinite(antes) && antes > price;

    if (was) {
      if (real) {
        was.textContent = formatCOP(antes);
        was.setAttribute('data-vt-amount', String(antes));
      }
      hideEl(was, !real);
      // El «Antes» solo para lector de pantalla va justo delante: sin tachado
      // detrás, se leería una palabra suelta sin cifra.
      var sr = was.previousElementSibling;
      if (sr && sr.classList.contains('vt-sr')) hideEl(sr, !real);
    }

    if (save) {
      var pct = real ? Math.round((antes - price) * 100 / antes) : 0;
      if (pct >= 1) save.textContent = 'Ahorras ' + pct + '%';
      hideEl(save, pct < 1);
    }
  }

  function initVariantes(scope) {
    all(scope, '[data-vt-variantes]').forEach(function (root) {
      if (!once(seen.variantes, root)) return;

      var section = (root.closest && (root.closest('[data-vt-product]') || root.closest('.shopify-section'))) || document;
      var data = section.querySelector('[data-vt-variantes-json]');
      if (!data) return;

      var variants;
      // Si el JSON viniera roto se sale sin tocar nada: mejor la ficha tal
      // como la pintó Liquid que un precio a medio cambiar.
      try { variants = JSON.parse(data.textContent || ''); }
      catch (err) { return; }
      if (!Array.isArray(variants) || !variants.length) return;

      // Posiciones de opción (1, 2, 3…) tal como las numera Liquid.
      var positions = [];
      all(root, '[data-vt-opcion]').forEach(function (c) {
        var p = parseInt(c.getAttribute('data-vt-opcion'), 10);
        if (isFinite(p) && positions.indexOf(p) < 0) positions.push(p);
      });
      positions.sort(function (a, b) { return a - b; });
      if (!positions.length) return;

      var optionOf = function (variant, i) {
        return (variant.options || [])[positions[i] - 1];
      };

      var chosen = function () {
        return positions.map(function (p) {
          var sel = root.querySelector('select[data-vt-opcion="' + p + '"]');
          if (sel) return sel.value;
          var radio = root.querySelector('input[data-vt-opcion="' + p + '"]:checked');
          return radio ? radio.value : null;
        });
      };

      var match = function (values) {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < values.length; j++) {
            if (optionOf(variants[i], j) !== values[j]) { ok = false; break; }
          }
          if (ok) return variants[i];
        }
        return null;
      };

      // Un valor es posible si existe una variante DISPONIBLE que lo lleve y
      // que respete lo ya elegido en las opciones anteriores. En cascada, no
      // cruzado: así el comprador siempre puede cambiar la primera opción y
      // no se queda encerrado con todo tachado.
      var posible = function (i, value, values) {
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k];
          if (!v.available) continue;
          if (optionOf(v, i) !== value) continue;
          var ok = true;
          for (var j = 0; j < i; j++) {
            if (optionOf(v, j) !== values[j]) { ok = false; break; }
          }
          if (ok) return true;
        }
        return false;
      };

      var markOptions = function (values) {
        positions.forEach(function (p, i) {
          var sel = root.querySelector('select[data-vt-opcion="' + p + '"]');
          if (sel) {
            Array.prototype.forEach.call(sel.options, function (o) {
              o.disabled = o.value !== sel.value && !posible(i, o.value, values);
            });
            return;
          }
          all(root, 'input[data-vt-opcion="' + p + '"]').forEach(function (r) {
            // Lo que está marcado nunca se deshabilita: dejaría un control
            // marcado y muerto. De que esa combinación no se puede pedir ya
            // avisa el mensaje de agotado.
            r.disabled = !r.checked && !posible(i, r.value, values);
          });
        });
      };

      var setBuyable = function (on) {
        all(section, '[data-vt-cta]').forEach(function (btn) {
          if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') {
            btn.disabled = !on;
            return;
          }
          // Es un <a>: `disabled` no existe en un enlace. Se marca con
          // aria-disabled (el CSS ya lo apaga), se saca del orden de foco y
          // el clic se corta más abajo.
          btn.setAttribute('aria-disabled', on ? 'false' : 'true');
          if (on) btn.removeAttribute('tabindex');
          else btn.setAttribute('tabindex', '-1');
        });

        // El formulario de contraentrega vive en OTRA sección: es el botón
        // que crea el pedido de verdad, y no puede crear uno agotado.
        var cod = document.querySelector('[data-vt-cod-form] [type="submit"]');
        if (cod) cod.disabled = !on;
      };

      var sync = function (fromUser) {
        var values = chosen();

        // Si alguna opción no tiene nada elegido, el selector está en un
        // estado que no sabemos leer: se deja la ficha como la pintó Liquid.
        // Ante la duda, nunca se apaga el botón de comprar.
        for (var i = 0; i < values.length; i++) {
          if (values[i] == null) return;
        }

        var variant = match(values);

        markOptions(values);

        var note = section.querySelector('[data-vt-disponibilidad]');
        var available = !!(variant && variant.available);
        hideEl(note, available);
        setBuyable(available);

        // Combinación inexistente: se avisa y se deja el precio anterior en
        // pantalla en vez de pintar una cifra inventada.
        if (!variant) return;

        all(section, '[data-vt-price]').forEach(function (box) { paintPrice(box, variant); });

        if (section.setAttribute) section.setAttribute('data-variante-id', String(variant.id));

        // Un solo querySelectorAll sincroniza la ficha y el formulario: el
        // id de la variante y el precio unitario que se le manda al backend.
        all(document, '[data-vt-variante]').forEach(function (el) { el.value = String(variant.id); });
        all(document, '[data-vt-precio]').forEach(function (el) {
          el.value = String(variant.price);
          paintTotal(totalRoot(el));
        });

        // El nombre de la variante en el resumen del pedido, solo si Liquid
        // lo pintó (un producto de variante única no lo tiene).
        all(document, '[data-vt-variante-titulo]').forEach(function (el) {
          if (variant.title) el.textContent = variant.title;
        });

        // Foto propia de la variante, si la tiene. Se borra el srcset o el
        // navegador seguiría mostrando la foto anterior.
        if (variant.image) {
          var main = section.querySelector('[data-vt-gallery] [data-vt-gallery-main]');
          if (main) {
            main.src = variant.image;
            main.removeAttribute('srcset');
          }
        }

        // Solo tras una elección del comprador: así, si recarga o comparte el
        // enlace, Liquid pinta la variante que eligió y no la primera.
        if (fromUser && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', String(variant.id));
            window.history.replaceState({}, '', url.toString());
          } catch (err2) { /* URL sin soporte: no vale la pena romper nada */ }
        }
      };

      var onChange = function (e) {
        if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-vt-opcion')) return;
        sync(true);
      };

      // El enlace deshabilitado se corta en captura para que tampoco lo
      // atienda el scroll suave del documento.
      var onGuard = function (e) {
        var dead = e.target instanceof Element ? e.target.closest('[data-vt-cta][aria-disabled="true"]') : null;
        if (!dead) return;
        e.preventDefault();
        e.stopPropagation();
      };

      root.addEventListener('change', onChange);
      section.addEventListener('click', onGuard, true);

      sync(false);

      remember(root, function () {
        root.removeEventListener('change', onChange);
        section.removeEventListener('click', onGuard, true);
      });
    });
  }

  /* ══ 8 · Página de gracias ════════════════════════════════════════════
     El número de pedido llega por la querystring (…/gracias?pedido=1042) y
     Liquid no puede leerla, así que el bloque nace con `hidden`. Sin esto,
     la confirmación nunca enseñaba el número: el comprador de contraentrega
     se queda sin nada que citar cuando llame a preguntar por su pedido. */

  function initGracias(scope) {
    all(scope, '[data-vt-order]').forEach(function (box) {
      if (!once(seen.gracias, box)) return;

      var out = box.querySelector('[data-vt-order-number]');
      if (!out) return;

      var param = (box.dataset && box.dataset.vtOrderParam) || 'pedido';
      var raw = '';
      try { raw = new URLSearchParams(window.location.search).get(param) || ''; }
      catch (err) { raw = ''; }

      // Viene de la URL: se pinta como texto (nunca como HTML), se limpia de
      // lo que no es un número de pedido y se recorta, para que nadie pueda
      // meter un párrafo dentro de la confirmación con un enlace preparado.
      var numero = raw.replace(/[^\w#\- ]+/g, '').trim().slice(0, 32);

      // Sin número no se enciende nada: mejor callar que enseñar «Tu número
      // de pedido:» seguido de un hueco.
      if (!numero) return;

      out.textContent = numero;
      box.hidden = false;
    });
  }

  /* ══ 9 · Cajón del carrito ════════════════════════════════════════════
     El marcado entero lo pinta snippets/vt-cart-drawer.liquid: este módulo no
     crea ni un nodo. Solo abre, cierra, atrapa el foco, habla con la API del
     carrito y sustituye el contenido de la zona repintable.

     LOS LISTENERS VIVEN EN `document`, delegados. El contenido del cajón se
     reemplaza entero en cada repintado, así que cualquier listener atado a sus
     nodos moriría con ellos — y el editor de temas, además, vuelve a montar la
     cabecera con un cajón nuevo. Delegando, no hay nada que reenganchar.

     SIN JAVASCRIPT NO SE ROMPE NADA: el icono del header conserva su href a
     /cart, el botón de pagar es un submit de verdad, el enlace de quitar lleva
     la URL que ya calculó Liquid y el formulario de agregar navega solo. Todo
     lo de aquí es preventDefault sobre marcado que ya funcionaba. */

  var CD = {
    root:     '[data-vt-cart-drawer]',
    panel:    '[data-vt-cart-drawer-panel]',
    velo:     '[data-vt-cart-drawer-overlay]',
    cerrar:   '[data-vt-cart-drawer-close]',
    contenido:'[data-vt-cart-drawer-content]',
    conteo:   '[data-vt-cart-drawer-count]',
    estado:   '[data-vt-cart-drawer-status]',
    error:    '[data-vt-cart-drawer-error]',
    subtotal: '[data-vt-cart-drawer-subtotal]',
    linea:    '[data-vt-cart-line]',
    cantidad: '[data-vt-cart-qty-input]',
    quitar:   '[data-vt-cart-remove]',
    abrir:    '[data-vt-cart-open]',
    burbuja:  '[data-vt-cart-count]'
  };

  // Los formularios de agregar: el hook propio primero y, si la sección no lo
  // puso, la acción de Shopify de toda la vida.
  var CD_ADD = 'form[data-vt-cart-add], form[action*="/cart/add"]';

  var CD_MSG = {
    fallo:    'No pudimos actualizar tu carrito. Revisa tu conexión e inténtalo otra vez.',
    agregado: 'Producto agregado al carrito.',
    quitado:  'Producto quitado del carrito.',
    vacio:    'No pudimos actualizar el carrito. Recarga la página, por favor.'
  };

  // El foco al que se vuelve al cerrar. Se guarda quién abrió, pero manda el
  // icono del carrito: es el sitio de la pantalla del que salió el panel.
  var cdUltimoFoco = null;

  function cdRoot() { return document.querySelector(CD.root); }
  function cdAbierto() { var r = cdRoot(); return !!(r && r.classList.contains('is-abierto')); }

  // La ruta del carrito se lee del marcado y no se escribe '/cart' a mano: la
  // tienda puede servirse bajo un prefijo de idioma o de país.
  function cdUrl(root) {
    var base = (root && root.getAttribute('data-vt-cart-drawer-url')) || '/cart';
    return base.replace(/\/+$/, '') || '/cart';
  }

  function cdConteoTexto(n) { return n === 1 ? '1 producto' : n + ' productos'; }

  /* ── avisos ── */

  // Lo que hay que oír sin verlo: el aria-live del panel es el único aviso que
  // recibe quien no ve la pantalla.
  //
  // EL AVISO SE ESCRIBE CON EL CAJÓN YA ABIERTO, NUNCA ANTES. La región vive
  // dentro de [data-vt-cart-drawer], que mientras está cerrado lleva
  // aria-hidden="true": lo que se escribe en una rama oculta al árbol de
  // accesibilidad no lo anuncia ningún lector de pantalla, y el mensaje se
  // pierde entero. Quien llame a esto tiene que abrir primero — ver cdAgregar.
  //
  // El retardo hace dos cosas a la vez: le da al lector el tiempo de reponer la
  // región en el árbol cuando el cajón acaba de abrirse, y separa el borrado de
  // la escritura, porque lo que se anuncia es el CAMBIO del nodo y escribir dos
  // veces seguidas el mismo texto no es un cambio (agregar dos veces el mismo
  // producto no decía nada la segunda vez).
  var cdAvisoTimer = null;

  function cdAnunciar(texto) {
    var root = cdRoot();
    var box = root && root.querySelector(CD.estado);
    if (!box) return;

    window.clearTimeout(cdAvisoTimer);
    box.textContent = '';
    if (!texto) return;

    cdAvisoTimer = window.setTimeout(function () {
      // Se vuelve a buscar el nodo: entre el borrado y la escritura el editor
      // de temas puede haber remontado la cabecera con un cajón nuevo.
      var r = cdRoot();
      var b = r && r.querySelector(CD.estado);
      if (b) b.textContent = texto;
    }, 120);
  }

  // El aviso visible vive FUERA de la zona repintable: si se borrara solo al
  // refrescar la lista, nadie llegaría a leerlo.
  function cdError(texto) {
    var root = cdRoot();
    var box = root && root.querySelector(CD.error);
    if (!box) return;
    if (!texto) { box.hidden = true; box.textContent = ''; return; }
    box.textContent = texto;
    box.hidden = false;
  }

  function cdOcupado(on) {
    var root = cdRoot();
    var content = root && root.querySelector(CD.contenido);
    if (!content) return;
    if (on) content.setAttribute('aria-busy', 'true');
    else content.removeAttribute('aria-busy');
  }

  /* ── abrir, cerrar y foco ── */

  var CD_FOCO = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function cdFocos(panel) {
    return all(panel, CD_FOCO).filter(function (el) {
      if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
      // Un nodo sin caja no se puede enfocar: lo que está oculto no cuenta.
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function cdFocarPanel() {
    var root = cdRoot();
    var panel = root && (root.querySelector(CD.panel) || root);
    if (!panel) return;
    // El foco entra al panel y no al primer botón: así se oye el título del
    // diálogo antes que un control suelto.
    try { panel.focus({ preventScroll: true }); }
    catch (err) { panel.focus(); }
  }

  // El fondo no scrollea mientras el cajón está abierto. La clase la pone aquí
  // y el overflow lo pone el CSS del snippet; la variable del ancho de la barra
  // de scroll evita el salto lateral en escritorio.
  function cdBloquearFondo(on) {
    var html = document.documentElement;
    if (on) {
      var sb = window.innerWidth - html.clientWidth;
      if (sb > 0) html.style.setProperty('--vt-cd-sb', sb + 'px');
      html.classList.add('vt-cd-abierto');
    } else {
      html.classList.remove('vt-cd-abierto');
      html.style.removeProperty('--vt-cd-sb');
    }
  }

  function cdSincronizarAbridores(on) {
    all(document, CD.abrir).forEach(function (el) {
      el.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function cdAbrir(trigger) {
    var root = cdRoot();
    if (!root) return false;
    if (trigger) cdUltimoFoco = trigger;
    else if (document.activeElement && !root.contains(document.activeElement)) cdUltimoFoco = document.activeElement;

    if (!root.classList.contains('is-abierto')) {
      cdBloquearFondo(true);
      root.classList.add('is-abierto');
      root.setAttribute('aria-hidden', 'false');
      cdSincronizarAbridores(true);
    }
    cdFocarPanel();
    return true;
  }

  function cdCerrar() {
    var root = cdRoot();
    if (!root || !root.classList.contains('is-abierto')) return;

    root.classList.remove('is-abierto');
    root.setAttribute('aria-hidden', 'true');
    cdSincronizarAbridores(false);
    cdBloquearFondo(false);

    // El foco vuelve al icono del carrito, venga el cierre de donde venga.
    // Dejarlo dentro de un panel que acaba de ocultarse lo manda al <body> y
    // quien navega con teclado se queda a oscuras.
    var volver = document.querySelector(CD.abrir) || cdUltimoFoco;
    if (volver && document.contains(volver)) {
      try { volver.focus({ preventScroll: true }); }
      catch (err) { volver.focus(); }
    }
    cdUltimoFoco = null;
  }

  /* ── red ── */

  // El carrito ES la sesión: sin la cookie de Shopify cada petición estrenaría
  // un carrito vacío. Aquí nunca va credentials:'omit', al revés que el POST
  // del formulario de contraentrega, que sale a un dominio ajeno.
  function cdJson(res) {
    return res.json().catch(function () { return null; }).then(function (body) {
      if (res.ok) return body;
      // Shopify contesta 422 con `description` cuando ya no queda inventario, y
      // ese texto explica el problema mejor que cualquier genérico nuestro.
      var texto = body && (body.description || body.message);
      var err = new Error(texto || ('HTTP ' + res.status));
      err.humano = texto ? String(texto) : '';
      throw err;
    });
  }

  /* Una red móvil colgada no puede dejar el cajón apagado para siempre:
     mientras hay una petición en vuelo el contenido está en aria-busy y no
     acepta toques, así que toda petición necesita un final. */
  function cdFetch(url, opciones) {
    var opts = opciones || {};
    var controller = ('AbortController' in window) ? new AbortController() : null;
    if (controller) opts.signal = controller.signal;
    var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 12000);

    return fetch(url, opts).then(function (res) {
      window.clearTimeout(timer);
      return res;
    }, function (err) {
      window.clearTimeout(timer);
      throw err;
    });
  }

  function cdPost(url, datos) {
    return cdFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(datos),
      credentials: 'same-origin'
    }).then(cdJson);
  }

  function cdLeerCarrito() {
    var root = cdRoot();
    return cdFetch(cdUrl(root) + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(cdJson);
  }

  /* ── pintar ── */

  /* Lo que se sabe al instante con el JSON del carrito: el número de la
     burbuja, el conteo del panel, el subtotal y las líneas que ya no existen.
     Va antes que el HTML del servidor porque es lo que hace que quitar un
     producto se sienta inmediato.

     Los pesos se formatean con formatCOP, y del otro lado Liquid los pinta con
     el snippet vt-cop, que agrupa exactamente igual. Antes el Liquid del cajón
     usaba el filtro `money` y estas mismas líneas se repintaban con formatCOP:
     el precio CAMBIABA de forma en cuanto se tocaba una cantidad. Dos cifras
     distintas del mismo carrito en la misma pantalla es exactamente lo que hace
     dudar a quien ya dudaba. Ninguno de los dos lados puede usar `money`. */
  function cdPintarDatos(cart) {
    if (!cart) return;
    var n = Number(cart.item_count) || 0;

    all(document, CD.burbuja).forEach(function (el) {
      el.textContent = String(n);
      hideEl(el, n === 0);
      // El icono lleva el conteo dentro del aria-label; sin esto, el lector de
      // pantalla seguiría diciendo el número con el que se cargó la página.
      var enlace = el.closest ? el.closest(CD.abrir) : null;
      if (enlace) enlace.setAttribute('aria-label', 'Carrito, ' + cdConteoTexto(n));
    });

    var root = cdRoot();
    if (!root) return;

    // Aquí se escribía data-vt-cart-drawer-items con el nº de artículos. No lo
    // leía nadie —ni el JS, ni el CSS, ni Liquid—, así que era un gancho muerto
    // que parecía una fuente de verdad y no lo era. El conteo que sí se usa es
    // el de [data-vt-cart-drawer-count] y el de la burbuja del header.

    var conteo = root.querySelector(CD.conteo);
    if (conteo) conteo.textContent = cdConteoTexto(n);

    var sub = root.querySelector(CD.subtotal);
    if (sub) sub.textContent = formatCOP(cart.total_price);

    var vivas = {};
    (cart.items || []).forEach(function (item) { vivas[item.key] = item; });

    all(root, CD.linea).forEach(function (li) {
      var item = vivas[li.getAttribute('data-vt-line-key')];
      if (!item) { li.parentNode && li.parentNode.removeChild(li); return; }

      var input = li.querySelector(CD.cantidad);
      if (input && String(item.quantity) !== input.value) input.value = String(item.quantity);

      // El precio de la línea se adelanta al HTML del servidor: al tocar el +,
      // la cifra cambia en el mismo gesto y no medio segundo después. Cuando
      // llega el repintado, Liquid vuelve a escribirla igual.
      var precio = li.querySelector('[data-vt-line-price], .vt-cd__price');
      if (precio) precio.textContent = formatCOP(item.final_line_price);

      var antes = li.querySelector('[data-vt-line-was], .vt-cd__was');
      if (antes) {
        var rebajado = Number(item.original_line_price) > Number(item.final_line_price);
        if (rebajado) antes.textContent = formatCOP(item.original_line_price);
        hideEl(antes, !rebajado);
      }

      li.classList.remove('is-cargando');
    });
  }

  /* El HTML manda: se le pide al servidor la sección de la cabecera y se
     trasplanta la zona repintable. Así los precios, los descuentos y el estado
     vacío los sigue pintando Liquid, con el mismo marcado y las mismas clases
     que el CSS del snippet espera — nada de reconstruir aquí una copia del
     Liquid que se separaría de él al primer cambio. */
  function cdRepintarHTML() {
    var root = cdRoot();
    var id = root && root.getAttribute('data-vt-cart-drawer-section');
    var content = root && root.querySelector(CD.contenido);
    if (!root || !id || !content) return Promise.resolve(false);

    var url = cdUrl(root) + '?section_id=' + encodeURIComponent(id);

    return cdFetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector(CD.contenido);
        if (!nuevo) throw new Error('la sección no trae el cajón');

        var teniaFoco = content.contains(document.activeElement);
        content.innerHTML = nuevo.innerHTML;

        // El conteo vive fuera de la zona repintada: se copia a mano.
        var conteoNuevo = doc.querySelector(CD.conteo);
        var conteo = root.querySelector(CD.conteo);
        if (conteoNuevo && conteo) conteo.textContent = conteoNuevo.textContent;

        // Los −/+ del marcado nuevo nacen muertos: hay que engancharlos otra vez.
        init(content);

        // Si el foco estaba en un nodo que acaba de desaparecer, se recoge en
        // el panel en vez de caer al <body>.
        if (teniaFoco && !content.contains(document.activeElement)) cdFocarPanel();
        return true;
      });
  }

  function cdEmitir(nombre, detalle) {
    var ev;
    try { ev = new CustomEvent(nombre, { detail: detalle, bubbles: true }); }
    catch (err) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(nombre, true, false, detalle);
    }
    document.dispatchEvent(ev);
  }

  // Cierre de cada mutación: pinta lo inmediato, pide el HTML bueno y avisa a
  // quien esté escuchando.
  function cdTrasCambio(cart) {
    cdPintarDatos(cart);
    cdEmitir('vt:carrito:cambiado', { cart: cart });
    return cdRepintarHTML().catch(function () {
      // Que falle el repintado con el carrito ya vacío deja un panel con
      // líneas que ya no existen: ahí sí hay que decirlo.
      if (cart && !cart.item_count) cdError(CD_MSG.vacio);
      return false;
    });
  }

  // Las mutaciones se encadenan. Dos toques rápidos en el + lanzaban dos
  // peticiones en carrera y pintaba la que respondiera última, que no siempre
  // es la última que tocó el comprador.
  var cdCola = Promise.resolve();

  function cdEnCola(fn) {
    cdCola = cdCola.catch(function () {}).then(fn);
    return cdCola;
  }

  function cdCambiar(key, cantidad, li) {
    if (!key) return;
    var root = cdRoot();
    if (!root) return;

    cdEnCola(function () {
      cdError('');
      cdOcupado(true);
      if (li) li.classList.add('is-cargando');

      return cdPost(cdUrl(root) + '/change.js', { id: key, quantity: cantidad })
        .then(function (cart) {
          cdAnunciar(cantidad === 0 ? CD_MSG.quitado : 'Cantidad actualizada a ' + cantidad + '.');
          return cdTrasCambio(cart);
        })
        .catch(function (err) {
          cdError(err && err.humano ? err.humano : CD_MSG.fallo);
          // Se vuelve a leer el carrito para que la cantidad del input sea la
          // de verdad y no la que el comprador acaba de intentar.
          return cdLeerCarrito().then(cdTrasCambio).catch(function () {});
        })
        .then(function () {
          cdOcupado(false);
          if (li) li.classList.remove('is-cargando');
        });
    });
  }

  function cdRefrescar() {
    return cdEnCola(function () {
      return cdLeerCarrito().then(cdTrasCambio).catch(function () {});
    });
  }

  /* ── agregar al carrito ── */

  function cdAgregar(form) {
    var root = cdRoot();
    // La FormData se arma ANTES de deshabilitar nada: un control deshabilitado
    // no viaja en el envío.
    var datos = new FormData(form);
    var boton = form.querySelector('[type="submit"]');

    if (boton) boton.disabled = true;
    cdError('');

    return cdFetch(cdUrl(root) + '/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: datos,
      credentials: 'same-origin'
    })
      .then(cdJson)
      .then(function () {
        if (boton) boton.disabled = false;
        // Primero el contenido, después la apertura y solo entonces el aviso.
        // El contenido antes que la apertura para que el cajón no se abra
        // enseñando el carrito de antes; el aviso DESPUÉS de abrir porque
        // mientras el cajón está cerrado su raíz lleva aria-hidden="true" y un
        // aria-live escrito ahí dentro no se anuncia nunca. Estaba al revés y
        // quien compraba con lector de pantalla no oía absolutamente nada al
        // agregar un producto.
        return cdRefrescar().then(function () {
          cdAbrir();
          cdAnunciar(CD_MSG.agregado);
        });
      })
      .catch(function (err) {
        if (boton) boton.disabled = false;
        throw err;
      });
  }

  /* ── delegación ── */

  function cdOnClick(e) {
    if (e.defaultPrevented) return;
    var t = e.target instanceof Element ? e.target : null;
    if (!t || !t.closest) return;

    var abridor = t.closest(CD.abrir);
    if (abridor) {
      // Ctrl/Cmd, Shift o el botón central: el comprador está pidiendo abrir el
      // carrito en otra pestaña y su href sigue siendo válido.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      // Sin cajón montado no se intercepta nada: el enlace navega a /cart.
      if (!cdRoot()) return;
      e.preventDefault();
      cdAbrir(abridor);
      return;
    }

    var root = cdRoot();
    if (!root || !root.contains(t)) return;

    if (t.closest(CD.velo) || t.closest(CD.cerrar)) {
      e.preventDefault();
      cdCerrar();
      return;
    }

    var rm = t.closest(CD.quitar);
    if (rm) {
      var key = rm.getAttribute('data-vt-line-key');
      // Sin clave no hay nada que pedirle a la API: que navegue el href de
      // Liquid, que quita la línea igual.
      if (!key) return;
      e.preventDefault();
      cdCambiar(key, 0, rm.closest(CD.linea));
    }
  }

  // El 'change' del input de cantidad es el mismo que ya dispara el módulo 5 al
  // tocar −/+, así que los botones no necesitan nada propio aquí.
  function cdOnChange(e) {
    var input = e.target instanceof Element ? e.target.closest(CD.cantidad) : null;
    if (!input) return;
    var root = cdRoot();
    if (!root || !root.contains(input)) return;

    var key = input.getAttribute('data-vt-line-key');
    var n = parseInt(input.value, 10);
    if (!key || !isFinite(n) || n < 0) return;
    cdCambiar(key, n, input.closest(CD.linea));
  }

  function cdOnKey(e) {
    if (!cdAbierto()) return;
    var root = cdRoot();

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      cdCerrar();
      return;
    }
    if (e.key !== 'Tab') return;

    var panel = root.querySelector(CD.panel) || root;
    var lista = cdFocos(panel);
    if (!lista.length) { e.preventDefault(); cdFocarPanel(); return; }

    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    var activo = document.activeElement;

    // El foco no sale del panel: circula del último al primero y al revés.
    if (!panel.contains(activo)) {
      e.preventDefault();
      (e.shiftKey ? ultimo : primero).focus();
    } else if (e.shiftKey && activo === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && activo === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  }

  function cdOnSubmit(e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || !form.matches || !form.matches(CD_ADD)) return;
    // Sin cajón en la página el formulario navega como siempre a /cart.
    if (!cdRoot()) return;

    e.preventDefault();

    cdAgregar(form).catch(function () {
      // El error no se traga: se deja que el formulario haga el envío nativo,
      // que lleva al carrito de verdad y enseña lo que Shopify tenga que decir.
      // form.submit() no vuelve a pasar por este listener, así que no hay bucle.
      try { form.submit(); }
      catch (err) { cdError(CD_MSG.fallo); }
    });
  }

  function initCartDrawer(scope) {
    all(scope, CD.root).forEach(function (root) {
      if (!once(seen.carrito, root)) return;

      // Nada que enganchar: los listeners son delegados y viven en `document`.
      // Aquí solo se deja el estado coherente con el marcado recién montado y
      // se apunta la limpieza para cuando el editor desmonte la cabecera: si el
      // cajón desaparece con el fondo bloqueado, el editor se queda sin scroll.
      var abierto = root.classList.contains('is-abierto');
      root.setAttribute('aria-hidden', abierto ? 'false' : 'true');
      cdSincronizarAbridores(abierto);
      if (!abierto) cdBloquearFondo(false);

      remember(root, function () { cdBloquearFondo(false); });
    });
  }

  /* ══ Arranque ═════════════════════════════════════════════════════════ */

  function init(scope) {
    var root = scope || document;
    initSticky(root);
    initGallery(root);
    initCodForm(root);
    initQty(root);
    // El total antes que las variantes: así el precio de la variante elegida
    // encuentra el total ya enganchado y lo repinta de una vez.
    initTotal(root);
    initVariantes(root);
    initGracias(root);
    initCartDrawer(root);
    // La barra fija y el formulario están en secciones distintas: cuando el
    // editor monta una, hay que volver a mirar si ya existe la otra.
    refreshStickyHide();
  }

  function destroy(scope) {
    all(scope, '[data-vt-sticky], [data-vt-gallery], [data-vt-cod-form], [data-vt-qty], [data-vt-total], [data-vt-variantes], [data-vt-cart-drawer]').forEach(function (el) {
      (teardowns.get(el) || []).forEach(function (fn) {
        try { fn(); } catch (err) { /* desmontar nunca puede tumbar la página */ }
      });
      teardowns.delete(el);
    });
  }

  // Un solo listener en el documento para todo el scroll suave: así funciona
  // también con lo que el editor inserte después.
  document.addEventListener('click', onScrollToClick);

  // El cajón del carrito, delegado en el documento: su contenido se sustituye
  // entero en cada repintado y unos listeners atados a esos nodos morirían con
  // ellos. Se registran una sola vez y valen para el cajón que haya.
  document.addEventListener('click', cdOnClick);
  document.addEventListener('change', cdOnChange);
  document.addEventListener('keydown', cdOnKey);
  document.addEventListener('submit', cdOnSubmit);

  // Puertas para el resto del tema: una sección puede abrir o refrescar el
  // cajón sin saber nada de este módulo.
  document.addEventListener('vt:carrito:abrir', function () { cdAbrir(); });
  document.addEventListener('vt:carrito:cerrar', function () { cdCerrar(); });
  document.addEventListener('vt:carrito:actualizado', function (e) {
    var cart = e && e.detail && e.detail.cart;
    // Si quien avisa ya leyó /cart.js, se aprovecha y se ahorra la petición.
    if (cart) cdEnCola(function () { return cdTrasCambio(cart); });
    else cdRefrescar();
  });

  // El editor de temas monta y desmonta secciones sin recargar la página: sin
  // esto, la sección que el comerciante acaba de insertar queda muerta.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });

  cfg().init = init;

  // Se carga con defer, así que el DOM ya está; la guarda es por si alguien
  // mueve la etiqueta <script> algún día.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
